import { Heading, Input, Table, TableContainer, Tbody, Td, Th, Thead, Tr, Button, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, InputGroup, InputLeftAddon } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import { getNochesUsuarios, liberarNoches, liberarNochesAll, putNochesUsuario, putNochesUsuarioAll } from "../../services/nochesUsuario"
import { useDidUpdateEffect } from "../../util/util"
import Pagination from "../util/pagination/pagination"
import InfoModal from "../util/confirmModal/InfoModal"
import ConfirmModal from "../util/confirmModal/confirmModal"
import { t } from "i18next"


const NochesUsuario = () => {
    const [loading, setLoading] = useState(false)
    const [nochesUsuario, setNochesUsuario] = useState([])

    const [page, setPage] = useState(1)
    const [totalPages, setTotalPages] = useState(0)
    const [search, setSearch] = useState(null)


    // MODAL DATA

    const infoModalDefault = {
        title: "",
        message: "",
        isOpen: false,
        isError: false,
        callback: null
    }

    const [infoModal, setInfoModal] = useState(infoModalDefault)

    const confirmModalDefault = {
        title: "",
        message: "",
        isOpen: false,
        onConfirm: null,
    }

    const [confirmModal, setConfirmModal] = useState(confirmModalDefault)


    const [isOpen, setIsOpen] = useState(false)

    const [idUsuario, setIdUsuario] = useState(null)
    const [isGlobal, setIsGlobal] = useState(false)
    const [numeroNoches, setNumeroNoches] = useState(28)
    const [nochesAlta, setNochesAlta] = useState(3)

    const [errorNumeroNoches, setErrorNumeroNoches] = useState(null)
    const [errorNochesAlta, setErrorNochesAlta] = useState(null)

    const handleCloseModal = () => {
        setIsOpen(false)
        setIdUsuario(null)
        setIsGlobal(false)
        setNumeroNoches(28)
        setNochesAlta(3)
        setErrorNumeroNoches(null)
        setErrorNochesAlta(null)
    }

    

    const checkInput = {
        checkNumeroNoches: async () => {
            if(numeroNoches === null || numeroNoches === undefined || numeroNoches === ""){
                setErrorNumeroNoches(t('FIELD_REQUIRED'));
                return false
            }
            if(isNaN(numeroNoches)){
                setErrorNumeroNoches(t('FIELD_MUST_BE_NUMBER'));
                return false
            }
            if(numeroNoches < 0){
                setErrorNumeroNoches(t('FIELD_GREATER_THAN_ZERO'));
                return false
            }
            setErrorNumeroNoches(false)
            return true
        },
        checkNochesAlta: async () => {
            if(nochesAlta === null || nochesAlta === undefined || nochesAlta === ""){
                setErrorNochesAlta(t('FIELD_REQUIRED'));
                return false
            }
            if(isNaN(nochesAlta)){
                setErrorNochesAlta(t('FIELD_MUST_BE_NUMBER'));
                return false
            }
            if(nochesAlta < 0){
                setErrorNochesAlta(t('FIELD_GREATER_THAN_ZERO'));
                return false
            }
            setErrorNochesAlta(false)
            return true
        },
        checkAll: async (skip=[]) =>{
            let result = true
            for(const key in checkInput){
                if(key === "checkAll" || skip.findIndex(itm => itm === key) !== -1){
                    continue
                }
                const response = await checkInput[key]()
                if(result && !response){
                    result = false
                }
            }
            return result
          }
    }

    const requestNochesUsuario = async () => {
        setLoading(true)
        try {
            const response = await getNochesUsuarios(page, search)
            setNochesUsuario(response.data.usuarios)
            setTotalPages(response.data.totalPages)
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const requestPutNochesUsuario = async () => {
        const isValid = await checkInput.checkAll()
        if(!isValid){
            return
        }
        setLoading(true)
        try {
            const response = await putNochesUsuario({
                id: idUsuario,
                numeroNoches: numeroNoches,
                nochesAlta: nochesAlta
            })
            if(response.status === 200){
                requestNochesUsuario()
                handleCloseModal()
                setInfoModal({
                    title: t('NIGHT_ASSIGNMENT'),
                    message: t('NIGHT_ASSIGNMENT_CONFIRM'),
                    isOpen: true,
                    isError: false,
                })
            }
        } catch (error) {
            console.log(error)
            const message = error.response && error.response.data && error.response.data.message ? error.response.data.msg : "Error al asignar las noches"
            setInfoModal({
                title: "Error",
                message: message,
                isOpen: true,
                isError: true,
            })
        } finally {
            setLoading(false)
        }
    }

    const requestSetAllNoches = async () => {
        const isValid = await checkInput.checkAll()
        if(!isValid){
            return
        }
        setLoading(true)
        try {
            const response = await putNochesUsuarioAll({
                numeroNoches: numeroNoches,
                nochesAlta: nochesAlta
            })
            if(response.status === 200){
                requestNochesUsuario()
                handleCloseModal()
                setInfoModal({
                    title: t('NIGHT_ASSIGNMENT'),
                    message: t('NIGHT_ASSIGNMENT_CONFIRM'),
                    isOpen: true,
                    isError: false,
                })
            }
        } catch (error) {
            console.log(error)
            const message = error.response && error.response.data && error.response.data.message ? error.response.data.msg : "Error al asignar las noches"
            setInfoModal({
                title: "Error",
                message: message,
                isOpen: true,
                isError: true,
            })
        } finally {
            setLoading(false)
        }
    }

    const handleCloseInfoModal = () => {
        setInfoModal(infoModalDefault)
    }

    useDidUpdateEffect(() => {
        const delayFunction = setTimeout(() => {
            if(page !== 1){
                setPage(1)
            }else{
                requestNochesUsuario()
            }
        }, 500)
        return () => clearTimeout(delayFunction)
    }, [search])

    useEffect(() => {
        requestNochesUsuario()
    }, [page])

    const requestLiberarNochesUsuario = async (liberarIdUsuario) => {
        setLoading(true)
        try {
            const response = await liberarNoches(liberarIdUsuario)
            if(response.status === 200){
                requestNochesUsuario()
                setInfoModal({
                    title: t('NIGHT_RELEASE'),
                    message: t('NIGHT_RELEASE_SUCCESS'),
                    isOpen: true,
                    isError: false,
                })
            }
        } catch (error) {
            console.log(error)
            const message = error.response && error.response.data && error.response.data.message ? error.response.data.msg : "Error al liberar las noches"
            setInfoModal({
                title: "Error",
                message: message,
                isOpen: true,
                isError: true,
            })
        } finally {
            setLoading(false)
        }
    }

    const requestLiberarAllNoches = async () => {
        setLoading(true)
        try {
            const response = await liberarNochesAll()
            requestNochesUsuario()
            setInfoModal({
                title: t('NIGHT_RELEASE_GLOBAL'),
                message: t('NIGHT_RELEASE_GLOBAL_SUCCESS'),
                isOpen: true,
                isError: false,
            })
        } catch (error) {
            console.log(error)
            const message = error.response && error.response.data && error.response.data.message ? error.response.data.msg : t('NIGHT_RELEASE_GLOBAL_ERROR')
            setInfoModal({
                title: "Error",
                message: message,
                isOpen: true,
                isError: true,
            })
        }
        finally {
            setLoading(false)
        }
    }


    const renderSetNochesModal = () => {
        return (
            <Modal isOpen={isOpen} onClose={handleCloseModal}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        {t('ASSIGN_NIGHTS')}
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <div className="form-group">
                            <label htmlFor="numeroNoches">{t('NUMBER_OF_NIGHTS')}</label>
                            <Input
                                id="numeroNoches"
                                type="number"
                                value={numeroNoches}
                                onChange={(e) => {
                                    setNumeroNoches(e.target.value)
                                    checkInput.checkNumeroNoches()
                                }}
                                onBlur={checkInput.checkNumeroNoches}
                            />
                            {errorNumeroNoches && (
                                <span className="text-danger">
                                    {errorNumeroNoches}
                                </span>
                            )}
                        </div>
                        <div className="form-group">
                            <label htmlFor="nochesAlta">{t('HIGH_SEASON_NIGHTS')}</label>
                            <Input
                                id="nochesAlta"
                                type="number"
                                value={nochesAlta}
                                onChange={(e) => {
                                    setNochesAlta(e.target.value)
                                }}
                                onBlur={checkInput.checkNochesAlta}
                            />
                            {errorNochesAlta && (
                                <span className="text-danger">
                                    {errorNochesAlta}
                                </span>
                            )}
                        </div>
                        <div style={{"textAlign": "right", marginTop: "20px", marginBottom: "20px"}}>
                            <Button
                                onClick={handleCloseModal}
                                mr={2}
                            >
                                {t('CANCEL')}
                            </Button>
                            <Button
                                colorScheme="blue"
                                isLoading={loading}
                                loadingText={t('SAVING')}
                                disabled={loading}
                                onClick={
                                    () => {
                                            isGlobal ? 
                                            setConfirmModal({
                                                title: t('ASSIGN_NIGHTS_GLOBALLY'),
                                                message: t('GLOBAL_ASSIGNMENT_CONFIRM'),
                                                isOpen: true,
                                                onConfirm: requestSetAllNoches,
                                            })
                                        :
                                            setConfirmModal({
                                                title: t('ASSIGN_NIGHTS'),
                                                message: t('NIGHT_ASSIGNMENT_CONFIRM'),
                                                isOpen: true,
                                                onConfirm: requestPutNochesUsuario,
                                            })
                                    }
                                }
                            >
                                {t('SAVE')}
                            </Button>
                        </div>
                    </ModalBody>
                </ModalContent>
            </Modal>
        )
    }

    return (
        <div className={"py-3 px-5"}>
            <Heading size={"lg"}>{t('NIGHTS')}</Heading>
            <div style={{width: '100%', display: 'flex'}}>
                <Input
                    placeholder={t('SEARCH')}
                    type="text"
                    onChange={(e) => {
                        setSearch(e.target.value)
                    }}
                    mt={4}
                    mb={4}
                />
                <div>
                    <Button
                        colorScheme="blue"
                        ml={2}
                        mt={4}
                        mb={4}
                        onClick={() => {
                            setConfirmModal({
                                title: t('NIGHT_RELEASE_GLOBAL'),
                                message: t('NIGHT_RELEASE_GLOBAL_CONFIRM'),
                                isOpen: true,
                                onConfirm: requestLiberarAllNoches
                            })
                        }}
                    >
                        {t('NIGHT_RELEASE_GLOBAL')}
                    </Button>
                </div>
                <div>
                    <Button
                        colorScheme="blue"
                        ml={2}
                        mt={4}
                        mb={4}
                        onClick={() => {
                            setIsOpen(true)
                            setIsGlobal(true)
                        }}
                    >
                        {t('ASSIGN_NIGHTS_GLOBALLY')}
                    </Button>
                </div>
            </div>
            <div
                className="mt-1"
                style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                }}
            >
                <TableContainer>
                    <Table variant='simple'>
                        <Thead>
                            <Tr>
                                <Th>{t('FIRST_NAME')}</Th>
                                <Th>{t('LAST_NAME')}</Th>
                                <Th>{t('EMAIL')}</Th>
                                <Th>{t('MEMBERSHIP_NUMBER')}</Th>
                                <Th>{t('CABIN_TYPE')}</Th>
                                <Th>{t('LOW_SEASON_NIGHTS')}</Th>
                                <Th>{t('HIGH_SEASON_NIGHTS')}</Th>
                                <Th></Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                nochesUsuario.map((noches) => (
                                    <Tr key={noches.id}>
                                        <Td>{noches.nombre}</Td>
                                        <Td>{noches.apellidos}</Td>
                                        <Td>{noches.correo}</Td>
                                        <Td>{noches.membresia}</Td>
                                        <Td>{noches.tipoCabana}</Td>
                                        <Td>{noches.numeroNoches}</Td>
                                        <Td>{noches.nochesAlta}</Td>
                                        <Td>
                                            <Button colorScheme="blue"
                                                onClick={() => {
                                                    setConfirmModal({
                                                        title: t('RELEASE_NIGHTS'),
                                                        message: t('RELEASE_NIGHTS_CONFIRM'),
                                                        isOpen: true,
                                                        onConfirm: () => requestLiberarNochesUsuario(noches.id)
                                                    })
                                                }}
                                                style={{ marginRight: '10px' }}
                                            >
                                                {t('RELEASE_NIGHTS')}
                                            </Button>
                                            <Button colorScheme="blue"
                                                onClick={() => {
                                                    setIdUsuario(noches.id)
                                                    setIsOpen(true)
                                                }}
                                            >
                                                {t('ASSIGN_NIGHTS')}
                                            </Button>
                                        </Td>
                                    </Tr>
                                ))
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
            </div>
            <InfoModal
                title={infoModal.title}
                message={infoModal.message}
                isOpen={infoModal.isOpen}
                onClose={handleCloseInfoModal}
                isError={infoModal.isError}
            />
            <ConfirmModal
                title={confirmModal.title}
                message={confirmModal.message}
                isOpen={confirmModal.isOpen}
                onClose={() => {
                    setConfirmModal(confirmModalDefault)
                }}
                onConfirm={() => {
                    confirmModal.onConfirm()
                    setConfirmModal(confirmModalDefault)
                }}
            />
            {
                renderSetNochesModal()
            }
            <Pagination
                pageCount={totalPages}
                currentPage={page}
                onPageChange={(page) => {
                    setPage(page)
                }}
            />
        </div>
    )
}

export default NochesUsuario;